// extracted by mini-css-extract-plugin
export default {"cta":"ZH-z","disabled":"_H-z"};